import React from "react";
import { useEffect } from "react";
import ImageComponent from "@src/stories/elements/Image/Image";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import 'photoswipe/style.css';

const Tiled = ({ images, onImageClick, galleryType, videoUrl, isGiftCard }) => {
  const handleVideoClick = () => {
    const videoElement = document.getElementById("product-video");
    if (videoElement) {
      const offset = -150; // Adjust this value as needed
      const elementPosition =
        videoElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      // @ts-ignore
      videoElement.querySelector("iframe").src += "&autoplay=1";
    }
  };

  useEffect(() => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: ".image-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  return (
    <>
      <div className="relative image-gallery">
        {videoUrl && (
          <div
            className="absolute m-[23px] cursor-pointer top-0 left-0 w-[104px] h-[152px] z-10 opacity-[0.6] shadow border border-white"
            onClick={handleVideoClick}
          >
            {images && images[1] && (
              <ImageComponent
                imageUrl={images[1].url}
                alt={images[1].alt}
                isLazy={true}
                classes="w-full h-full object-cover"
              />
            )}
            <div className="absolute inset-0 flex items-center justify-center">
              <svg
                className="w-12 h-12 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
        )}
        {images.map((image, index) => (
          <a
            key={index}
            href={image.url}
            data-pswp-src={image.url}
            data-pswp-width={image.width || 2000}
            data-pswp-height={image.height || 3000}
            data-cropped="true"
            className="image-item"
            onClick={(e) => {
              e.preventDefault();
              onImageClick(image);
            }}
          >
            <ImageComponent
              imageUrl={image.url}
              alt={image.alt || 'Product image'}
              isLazy={index > 1} // Don't lazy load first 2 images
              priority={index === 0} // Prioritize first image
              classes="w-full h-full object-cover"
              sizes="(max-width: 768px) 100vw, 60vw"
            />
          </a>
        ))}
        {videoUrl && (
          <div id="product-video" key={"video"} className="video-item">
            <div
              className="relative top-0 left-0 object-cover w-full h-full video-iframe"
              data-v-2da62827=""
            >
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src={videoUrl}
                width="100%"
                height="100%"
                data-v-2da62827=""
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Tiled;
